<header #header [ngClass]="{'active': layout.sidebar}" attr.media="{{layout.media('header')}}"></header>
<div #body>
  <sidebar #sidebar (click)="hideSidebar($event)" [ngClass]="{'active' : layout.sidebar}"></sidebar>
  <div>    
    <div #content>
      <router-outlet (activate)='update()'></router-outlet>
    </div>
    <footer #footer attr.media="{{layout.media('footer')}}"></footer>
    <scrollbar class="right"></scrollbar>
  </div>
</div>
